import API from "shared/services/Api";
import { IIndicationScience } from "shared/types/IndicationScience";

export const sendIndicationScience = async (
  data: IIndicationScience,
  userId: string
) => API.post(`oc/referrals/surgical-indication?id=${userId}`, data);
